import * as d3 from 'd3'
export default {

  methods: {

    draw_Status() {

      let status = this.canvasForms
      .append('g')
      .attr('transform', `translate(0, ${this.status.y})`)

      let bx = 0
      this.columns.forEach(d=> {

        if(d.code != this.status.totalRef) {
          let raWidth = (this.status.width * d.ratio)/this.status.ratio
          status
          .append('rect')
          .attr('x', bx).attr('y', -11).attr('rx', 3)
          .attr('width', raWidth).attr('height', 6)
          .attr('fill', d.bColor).attr('stroke-width', 0)
          bx = bx + raWidth
        }

        status
        .append('rect')
        .attr('x', d.sx).attr('y', 0)
        .attr('width', 2).attr('height', this.status.barHeight)
        .attr('fill', d.bColor).attr('stroke-width',0)
        .attr('opacity', 1)

        status // Name
        .append('text')
        .attr('x', d.sx + 5).attr('y', this.status.name.tSize*0.75)
        .attr('fill', this.status.name.tColor).attr('font-size', this.status.name.tSize)
        .attr('text-anchor', 'start')
        .text(d.name)

        status // Value
        .append('text')
        .attr('x', d.sx + 5).attr('y', this.status.value.y + this.status.value.tSize*0.75)
        .attr('fill', this.status.value.tColor).attr('font-size', this.status.value.tSize)
        .attr('text-anchor', 'start')
        .text(this.gmx_numFormat(d.value, '$') + this.status.value.unit)
        .call(this.event_Link, d)


        if(d.delta == 'Y') {
          status // Weekly Delta
          .append('text')
          .attr('x', d.ex -12).attr('y', this.status.week.tSize*0.75)
          .attr('fill', d.week>0 ? '#44A9DF' : '#EC407A').attr('font-size', this.status.week.tSize)
          .attr('text-anchor', 'end')
          .text(d.week + this.status.week.unit)

          status // Delta Icon
          .append('path')
          .attr('transform', `translate(${d.ex - 10}, 0) scale(.7)`)
          .attr('d', d.week>0 ? this.icon.cUp : this.icon.cDown)
          .attr('fill', d.week>0 ? '#44A9DF' : '#EC407A')
        }

      })

    },

  } 
}